import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/19/principle/plot-15-on-walls.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Sound sample",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
      url: `${config.ASSETS_URL}/02/19/principle/15-on-walls.wav`,
    },
  },
];
